export const tabsTypes = {
  MONITORING: 'monitoring',
  SUPPLY_CHAIN: 'supplyChain',
};

export const monitoringTabs = [
  {
    key: 'focusArea',
    label: 'Focus Area',
  },
  {
    key: 'additionalSutbjects',
    label: 'Additional Subjects',
  },
  {
    key: 'informationSources',
    label: 'Information Sources',
  },
];

export const supplyChainTabs = [
  {
    key: 'materialFlow',
    label: 'Material Flow',
  },
  {
    key: 'additionalSutbjects',
    label: 'Additional Subjects',
  },
  {
    key: 'informationSources',
    label: 'Information Sources',
  },
];
